module.exports = __webpack_public_path__ + "img/logo-olli.9744132c.png";